import { ItemTypeConsts, StoreModelMap, StoreModuleMap } from 'client/util/Constants';
import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';

const orgModel = StoreModelMap[ItemTypeConsts.organizations];
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const appAuthorizationCollection = 'AppAuthorizationCollection';

/**
 * This mixin provides the functionality to load the current organization
 * settings in order to be able to read/update the deviceIdentificationEnabled option
 * on different pages
 *
 * Note that we use the `authNPoliciesCert` prefix to avoid possible import collisions with other
 * mixins or imports
 */
export default {
  computed: {
    ...mapState(settingsModule, {
      authNPoliciesCertOrgId: 'orgId',
    }),
    ...mapState(orgModel, {
      authNPoliciesCertItem: 'item',
      authNPoliciesCertPreviousItem: 'previousItem',
    }),

    getDeviceIdentificationEnabled() {
      return get(this.authNPoliciesCertItem, 'settings.deviceIdentificationEnabled');
    },

    getTrustedAppsConfig() {
      return get(this.authNPoliciesCertItem, 'settings.trustedAppConfig.trustedApps');
    },
  },

  methods: {
    ...mapActions(orgModel, {
      authNPoliciesCertFetchItem: 'fetchItem',
      authNPoliciesCertSetItemField: 'setItemField',
      authNPoliciesUpdateTrustedApps: 'updateTrustedAppsSettings',
    }),

    ...mapActions(appAuthorizationCollection, [
      'setCollectionToCustomApps',
      'setCollectionToRecommendedApps',
    ]),

    async initializeCertificateSettings() {
      await this.authNPoliciesCertFetchItem(this.authNPoliciesCertOrgId);
    },

    async initializeTrustedAppsSettings() {
      const deviceCertEnabled = this.getDeviceIdentificationEnabled;
      const trustedApps = this.getTrustedAppsConfig;
      if (deviceCertEnabled) {
        if (trustedApps && trustedApps.length > 0) {
          await this.setCollectionToCustomApps(trustedApps);
        } else {
          const jumpcloudTrustedApps = await this.setCollectionToRecommendedApps();
          this.authNPoliciesUpdateTrustedApps(jumpcloudTrustedApps);
        }
      }
    },
  },
};
